import styled from "styled-components";

export const SecuriteWrapper = styled.div`
  background: white;
  > div {
    padding-left: 15%;
    padding-right: 15%;
    :first-child {
      padding-left: 0;
      padding-right: 0;
    }
  }
  .title {
    padding-left: 19%;
    padding-right: 20%;
    font-size: 35px;
    margin-top: 50px;
    font-weight: bold;
  }
  .reponses {
    padding-left: 20%;
    padding-right: 20%;
    padding-bottom: 40px;
    display: flex;
    color: #718096;
    .question {
      font-size: 25px;
    }
    .gauche {
      flex: 1;
      padding-right: 2%;
    }
    .droite {
      flex: 1;
      padding-left: 2%;
    }
  }
  .jobs {
    background: #80dd93;
    padding-bottom: 50px;
    padding-top: 10px;
    margin-top: 80px;
    text-align: center;

    .title {
      font-size: 30px;
      color: black;
      font-weight: bold;
    }
    .txt {
      font-size: 30px;
    }
    .btn {
      margin-left: auto;
      margin-right: auto;
      border-radius: 20px;
      font-size: 25px;
      background: gray;
      color: white;
      height: 40px;
      padding: 2%;
      margin-top: 20px;

      &:hover {
        color: white;
        font-weight: normal;
      }
    }
  }

  @media (max-width: 1024px) {
    > div {
      padding-right: 3%;
      padding-left: 3%;
      :first-child {
        padding-left: 0;
        padding-right: 0;
      }
    }
    .title {
      padding-left: 0;
      padding-right: 0;
      text-align: center;
      font-size: 26px;
    }
    .reponses {
      padding-left: 3%;
      padding-right: 3%;
      flex-direction: column;
    }
    .gauche,
    .droite {
      padding: 0px !important;
    }
    .gauche {
      img {
        padding-top: 50px;
        margin-right: auto;
        margin-left: auto;
      }
    }
    .jobs {
      .btn {
        font-size: 20px;
      }
    }
  }

  .headerSecuriteWrapper {
    background: #142a3f;
    clip-path: polygon(0 0, 100% 0, 100% 80%, 0% 100%);

    .wrap {
      padding-right: 15%;
      padding-left: 15%;
      padding-top: 130px;
      padding-bottom: 35px;
      display: flex;
      .gauche {
        flex: 1;
        .title {
          padding: 0;
          color: #ffa400;
          font-weight: bold;
          font-size: 35px;
          margin-bottom: 30px;
        }
        .txt {
          font-size: 25px;
          color: white;
        }
      }
      .droite {
        flex: 1;
        border-radius: 60px;
        text-align: center;
        svg {
          width: 60%;
          height: 60%;
          color: #4ca6e2;
        }
      }
    }

    @media (max-width: 1024px) {
      > div {
        padding-right: 3% !important;
        padding-left: 3% !important;
      }
      .wrap {
        flex-direction: column;
        padding-top: 10px;
        .txt {
          text-align: center;
        }
      }
    }
  }
`;
